import Input from 'components/Input'
import SelectOption from 'components/SelectOption'
import styled, { css } from 'styled-components'
import { color } from 'utils'

const errorStyles = css`
  border-color: ${color('red600')};
`

const darkFormStyles = css`
  background: transparent;
  color: ${color('white')};

  &:active:not(:disabled),
  &:focus:not(:disabled) {
    background: transparent;
    border-color: ${color('dark000')};
    color: ${color('white')};
  }

  &:active:not(:disabled):not([readonly]),
  &:focus:not(:disabled):not([readonly]) {
    background: transparent;
    border-color: ${color('dark000')};
    color: ${color('white')};
  }
`

export const StyledSelectOption = styled(SelectOption)`
  select {
    ${darkFormStyles}
  }

  &::after {
    border-top-color: ${color('dark000')};
  }
`

export const StyledInput = styled(Input)<{ error?: boolean }>`
  input {
    ${darkFormStyles}

    ${({ error }) => error && errorStyles}
  }
`
